// PRO-EMAIL

export const receiveProEmailPaymentMethods = response => (Object.entries(response.data.data).filter(paymentMethod => paymentMethod[1].selectable));
